import { AxiosResponse } from 'axios';
import {
  Equipment,
  EquipmentForm,
  EquipmentView,
  OccurrenceView,
  Pagination,
} from '~/types';
import api from '~/utils/api';
import { addFormattedPropertiesToOccurence } from '..';

export async function getEquipments(
  page: number,
  search: string,
  pageSize: number,
): Promise<Pagination<EquipmentView>> {
  const { data } = await api.get<Pagination<Equipment>>('/equipamentos', {
    params: {
      page,
      size: pageSize,
      ...(search ? { search } : {}),
    },
  });

  const equipments = data.results.map(equipment => ({
    ...equipment,
    formattedStatus: equipment.tp_situacao === '1' ? 'ATIVO' : 'INATIVO',
    colorScheme: equipment.tp_situacao === '1' ? 'green' : 'red',
    status: equipment.tp_situacao === '1',
    formattedOccurrences: [] as OccurrenceView[],
  }));

  return {
    ...data,
    results: equipments,
  };
}

export async function getEquipmentById(id: string): Promise<EquipmentView> {
  const { data } = await api.get<Equipment>(`/equipamentos/${id}`);

  const equipment = {
    ...data,
    formattedStatus: data.tp_situacao === '1' ? 'ATIVO' : 'INATIVO',
    colorScheme: data.tp_situacao === '1' ? 'green' : 'red',
    status: data.tp_situacao === '1',
    formattedOccurrences:
      data?.chamados?.map(occurrence =>
        addFormattedPropertiesToOccurence(occurrence),
      ) || [],
  };

  return equipment;
}

export async function updateEquipmentById(
  id: string,
  data: EquipmentForm,
): Promise<AxiosResponse<any>> {
  return api.put(`/equipamentos/${id}`, data);
}

export async function createEquipment(
  data: EquipmentForm,
): Promise<AxiosResponse<any>> {
  return api.post('/equipamentos', data);
}

export async function deleteEquipment(id: string): Promise<AxiosResponse<any>> {
  return api.delete(`/equipamentos/${id}`);
}

export async function deleteDuplicates(): Promise<AxiosResponse<any>> {
  return api.post('/reset/equipamentos');
}

export async function getEquipmentsByArrayOfIds(
  ids: number[],
): Promise<EquipmentView[]> {
  const responses: EquipmentView[] = [];

  return new Promise((resolve, rejects) => {
    async function getData(id: string) {
      return getEquipmentById(id)
        .then(equipmentView => {
          responses.push(equipmentView);

          if (ids.length) {
            const equipmentId = ids.shift();
            if (equipmentId) getData(String(equipmentId));
            return equipmentView;
          }
          return resolve(responses);
        })
        .catch(() => {
          return rejects(responses);
        });
    }
    const id = ids.shift();
    if (id) getData(String(id));
  });
}
